// src/stage2/S2LifeMeter.jsx
import React from "react";

import Mood from "./Life Meters/Mood";
import Temperature from "./Life Meters/Temperature";
import SleepSwitch from "./Life Meters/SleepSwitch";
import FullTank from "./Life Meters/FullTank.jsx";
import RingCounter from "./Life Meters/RingCounter.jsx";
import SocialDots from "./Life Meters/SocialDots.jsx";

export default function S2LifeMeter({
  score,
  isSleepSwitchOn,
  setIsSleepSwitchOn,
  setArrowPosition,

  // RINGS OF ENCOURAGEMENT COUNTER
  ringCurrent = 0,
  ringTop = 0,
  ringLast = 0,
}) {
  return (
    <div className="life-meter-container">
      <RingCounter current={ringCurrent} top={ringTop} last={ringLast} />
{/* 
      <SleepSwitch
        isOn={isSleepSwitchOn}
        setIsOn={setIsSleepSwitchOn}
        setIsSleepSwitchOn={setIsSleepSwitchOn}
      /> */}

      <SocialDots filled={4} total={4}/>

      <Temperature isSleeping={!isSleepSwitchOn} />

{/** THE TANK SHOUDL BE MORE LIKE A BALNACE BETWEEN PLAY AND WORK
 * No longer "empty/full" as bladder/stomach/body but 
 * "oversaturated, tired, played out or worked-out"
 * The key is not regulating the tank but keeping balance between work and play. 
 * Not sure how to re-factor this bit quite yet. Both work adn play are "good" and "bad" so green/red doesn't wokr. 
 * Also, starting choudl be "center" adn left or right fills based on indoor/outdoor. and once full, then encouraged to 
 * go outside and play" or "chime the shchool bell and all dots line up and go inside." -- does player follow or keep playing?
 */}
      <FullTank value={score} total={5} />


      <Mood setArrowPosition={setArrowPosition} />
    </div>
  );
}
